import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export interface EmailIssuedFormParams {
  issuedFormId: string;
  templateOverride?: EmailTemplate;
}

async function emailForm(params: EmailIssuedFormParams): Promise<boolean> {
  if (params === undefined) {
    return false;
  }

  // make api call
  const result = await privateApi.post(
    `${import.meta.env.VITE_API_BASE_URL}/forms/issued/${params.issuedFormId}/email`,
    {
      templateOverride: params.templateOverride,
    },
  );

  return !!result.data;
}

const useEmailForm = createMutation<boolean, EmailIssuedFormParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: EmailIssuedFormParams) => emailForm(variables),
});

export { emailForm, useEmailForm };
